import { defineComponent as _defineComponent } from 'vue'
import NavigationBar from "../shared/NavigationBar.vue";
import StreetView from "@/components/map/StreetView.vue";


const __default__ = {
  name: "BusStopStreetView",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  latitude: {
    type: Number,
    default: 37.4044893,
  },
  longitude: {
    type: Number,
    default: 127.0982259,
  },
  title: {
    type: String,
    default: "정류장 거리뷰",
  },
},
  emits: ["onClickClose"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const emitOnClickClose = () => {
  emit("onClickClose");
};

const __returned__ = { props, emit, emitOnClickClose, NavigationBar, StreetView }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})